(function(angular){
	'use strict';
	
	var featuredPropertyListObject = {
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		bindings: {
			properties: '<'
		},
		controllerAs: 'featuredPropertyList'
	};
	
	angular
		.module('featuredPropertyListingModule')
		.component('featuredPropertyList', featuredPropertyListObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/featured-property-list/featured-property-list.html';
	}
})(window.angular);